import { createSelector } from '@ngrx/store';

import { routerState } from '../root';

export const getHistoryRoute = createSelector(routerState, (router) => router?.history);
